export default __webpack_public_path__ + "static/media/Mandoline.b713bc35.pdf";